module.exports = __webpack_public_path__ + "assets/img/faspay_812.06f838af.png";